export const time_condition = {
  modal: {
    remove: {
      content: `Are you sure you want to delete the time condition <b>{name}<b>?`
    },

    add_interval: {
      days: 'Select days of the week',
      worktime: 'Working hours'
    }
  },

  form: {
    title: {
      edit: {
        main: 'Time condition data'
      }
    },

    buttons: {
      create_time_interval: 'Add Interval'
    }
  },

  table: {
    field: {
      timezone: 'Timezone'
    }
  }
};
